export default function SvgSprite() {
  return (
    <svg
      width="0"
      height="0"
      style={{ position: "absolute" }}
      aria-hidden="true"
    >
      <defs>
        <symbol id="ic-shield" viewBox="0 0 24 24">
          <path d="M12 3l7 3v6c0 4.5-3 8-7 9-4-1-7-4.5-7-9V6l7-3z" />
          <path d="M9 12l2 2 4-4" />
        </symbol>
        <symbol id="ic-car" viewBox="0 0 24 24">
          <path
            d="M1.75 13.75L3.8 8.63C4.24 7.54 5.3 6.85 6.48 6.85H16.12C17.25 6.85 18.26 7.5 18.73 8.53L20.85 13.18C21.84 13.58 22.5 14.56 22.5 15.65V16.75C22.5 17.44 21.94 18 21.25 18H20.08C19.56 19.46 18.17 20.5 16.5 20.5C14.83 20.5 13.44 19.46 12.92 18H10.58C10.06 19.46 8.67 20.5 7 20.5C5.33 20.5 3.94 19.46 3.42 18H2.75C2.06 18 1.5 17.44 1.5 16.75V15.5C1.5 14.73 1.95 14.06 2.6 13.73ZM7 19C7.83 19 8.5 18.33 8.5 17.5C8.5 16.67 7.83 16 7 16C6.17 16 5.5 16.67 5.5 17.5C5.5 18.33 6.17 19 7 19ZM16.5 19C17.33 19 18 18.33 18 17.5C18 16.67 17.33 16 16.5 16C15.67 16 15 16.67 15 17.5C15 18.33 15.67 19 16.5 19ZM6.3 8.35C5.78 8.35 5.32 8.66 5.12 9.14L3.75 12.5H11.25V8.35H6.3ZM12.75 8.35V12.5H19.25L17.75 9.22C17.55 8.7 17.06 8.35 16.5 8.35H12.75Z"
            fill="currentColor"
            stroke="none"
          />
        </symbol>
        <symbol id="ic-clock" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 3" />
        </symbol>
        <symbol id="ic-tag" viewBox="0 0 24 24">
          <path d="M20 12l-8 8-9-9V4h7l10 8z" />
          <circle cx="7.5" cy="7.5" r="1.2" />
        </symbol>
        <symbol id="ic-headset" viewBox="0 0 24 24">
          <path d="M4 13v-1a8 8 0 0116 0v1" />
          <rect x="3" y="13" width="4" height="6" rx="1.5" />
          <rect x="17" y="13" width="4" height="6" rx="1.5" />
          <path d="M20 19a4 4 0 01-4 3h-2" />
        </symbol>
        <symbol id="ic-check-shield" viewBox="0 0 24 24">
          <path d="M12 3l7 3v6c0 4.5-3 8-7 9-4-1-7-4.5-7-9V6l7-3z" />
          <path d="M9 12l2 2 4-4" />
        </symbol>
        <symbol id="ic-sparkle" viewBox="0 0 24 24">
          <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M18 6l-2.5 2.5M8.5 15.5L6 18" />
        </symbol>
        <symbol id="ic-plane" viewBox="0 0 24 24">
          <path d="M10.5 21l1.5-4 1.5 4h-3zM3 15l18-6-6 6-2 5-2-3-5-2z" />
        </symbol>
        <symbol id="ic-users" viewBox="0 0 24 24">
          <circle cx="9" cy="8" r="3.2" />
          <path d="M2.5 20a6.5 6.5 0 0113 0" />
          <circle cx="17" cy="9" r="2.6" />
          <path d="M15 20a5.5 5.5 0 016.5-5.4" />
        </symbol>
        <symbol id="ic-briefcase" viewBox="0 0 24 24">
          <rect x="3" y="7" width="18" height="12" rx="2" />
          <path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2" />
        </symbol>
        <symbol id="ic-heart" viewBox="0 0 24 24">
          <path d="M12 20s-7-4.4-9.5-9A5.5 5.5 0 0112 5.5 5.5 5.5 0 0121.5 11c-2.5 4.6-9.5 9-9.5 9z" />
        </symbol>
        <symbol id="ic-map" viewBox="0 0 24 24">
          <path d="M9 18l-6 2V6l6-2 6 2 6-2v14l-6 2-6-2z" />
          <path d="M9 4v14M15 6v14" />
        </symbol>
        <symbol id="ic-route" viewBox="0 0 24 24">
          <circle cx="5" cy="6" r="2" />
          <circle cx="19" cy="18" r="2" />
          <path d="M5 8v3a3 3 0 003 3h5a3 3 0 013 3v1" />
        </symbol>
        <symbol id="ic-doc" viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
          <path d="M14 2v6h6" />
          <path d="M16 13H8" />
          <path d="M16 17H8" />
          <path d="M10 9H8" />
        </symbol>
        <symbol id="ic-ticket" viewBox="0 0 24 24">
          <path d="M3 9a2 2 0 002-2V5a2 2 0 012-2h10a2 2 0 012 2v2a2 2 0 002 2v6a2 2 0 00-2 2v2a2 2 0 01-2 2H7a2 2 0 01-2-2v-2a2 2 0 00-2-2V9z" />
          <path d="M9 12h6M12 9v6" />
        </symbol>
        <symbol id="ic-star" viewBox="0 0 24 24">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill="currentColor" stroke="none" />
        </symbol>
        <symbol id="ic-search" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8" />
          <path d="M21 21l-4.35-4.35" />
        </symbol>
        <symbol id="ic-arrow-left" viewBox="0 0 24 24">
          <path d="M20 12H4M10 18l-6-6 6-6" />
        </symbol>
        <symbol id="ic-arrow-right" viewBox="0 0 24 24">
          <path d="M4 12h16M14 6l6 6-6 6" />
        </symbol>
        <symbol id="ic-phone" viewBox="0 0 24 24">
          <path d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z" />
        </symbol>
        <symbol id="ic-whatsapp" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            stroke="none"
            d="M12 2a10 10 0 00-8.6 15L2 22l5.2-1.4A10 10 0 1012 2zm5.6 14.3c-.2.6-1.3 1.2-1.9 1.3-.5.1-1.1.1-1.7-.1-.4-.1-.9-.3-1.6-.6-2.8-1.2-4.6-4-4.7-4.2-.1-.2-1.1-1.5-1.1-2.8 0-1.3.7-2 1-2.2.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5.2.5.7 1.8.8 1.9.1.2.1.3 0 .5-.1.2-.1.3-.3.5l-.4.5c-.1.2-.3.3-.1.6.2.3.9 1.5 1.9 2.4 1.3 1.2 2.4 1.5 2.7 1.7.3.2.5.1.6-.1l.9-1c.2-.3.4-.2.6-.1l1.7.8c.2.1.3.2.4.3.1.2.1.9-.1 1.5z"
          />
        </symbol>
        <symbol id="ic-mail" viewBox="0 0 24 24">
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="M3 7l9 6 9-6" />
        </symbol>
        <symbol id="ic-pin" viewBox="0 0 24 24">
          <path d="M12 22s7-6.8 7-12a7 7 0 10-14 0c0 5.2 7 12 7 12z" />
          <circle cx="12" cy="10" r="2.5" />
        </symbol>
        <symbol id="ic-instagram" viewBox="0 0 24 24">
          <rect x="3" y="3" width="18" height="18" rx="5" />
          <circle cx="12" cy="12" r="4" />
          <circle cx="17.3" cy="6.7" r="1" />
        </symbol>
        <symbol id="ic-google" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="9" />
          <path d="M8 12h8M12 8v8" />
        </symbol>
        <symbol id="ic-menu" viewBox="0 0 24 24">
          <path d="M4 6h16M4 12h16M4 18h16" />
        </symbol>
        <symbol id="ic-plus" viewBox="0 0 24 24">
          <path d="M12 5v14M5 12h14" />
        </symbol>
        <symbol id="ic-eye" viewBox="0 0 24 24"><path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z" /><circle cx="12" cy="12" r="2.5" /></symbol>
        <symbol id="ic-check" viewBox="0 0 24 24"><path d="M5 12l4 4L19 6" /></symbol>
        <symbol id="ic-trash" viewBox="0 0 24 24"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 14h10l1-14M9 7V4h6v3" /></symbol>
        <symbol id="ic-restore" viewBox="0 0 24 24"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" /><path d="M3 3v5h5" /></symbol>
        <symbol id="ic-edit" viewBox="0 0 24 24"><path d="M4 17.5V20h2.5L19 7.5 16.5 5 4 17.5zM15 6.5l2.5 2.5" /></symbol>
        <symbol id="ic-close" viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19" /></symbol>
        <symbol id="ic-calendar" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M7 3v4M17 3v4M3 10h18" /></symbol>
        <symbol id="ic-dash" viewBox="0 0 24 24">
          <rect x="3" y="3" width="8" height="8" rx="1.5" />
          <rect x="13" y="3" width="8" height="8" rx="1.5" />
          <rect x="3" y="13" width="8" height="8" rx="1.5" />
          <rect x="13" y="13" width="8" height="8" rx="1.5" />
        </symbol>
        <symbol id="ic-truck" viewBox="0 0 24 24">
          <path d="M2 8h11v9H2z" />
          <path d="M13 11h4l4 4v2h-8z" />
          <circle cx="6.5" cy="18.5" r="1.6" />
          <circle cx="17.5" cy="18.5" r="1.6" />
        </symbol>
        <symbol id="ic-inbox" viewBox="0 0 24 24">
          <path d="M3 12h5l2 3h4l2-3h5" />
          <path d="M5 5h14l2 7v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6l2-7z" />
        </symbol>
        <symbol id="ic-settings" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="3" />
          <path d="M19 12a7 7 0 00-.1-1.3l2-1.6-2-3.4-2.4.9a7 7 0 00-2.2-1.3L14 2h-4l-.3 2.3A7 7 0 007.5 5.6l-2.4-.9-2 3.4 2 1.6A7 7 0 005 12c0 .4 0 .9.1 1.3l-2 1.6 2 3.4 2.4-.9c.7.6 1.4 1 2.2 1.3L10 22h4l.3-2.3c.8-.3 1.5-.7 2.2-1.3l2.4.9 2-3.4-2-1.6c.1-.4.1-.9.1-1.3z" />
        </symbol>
        <symbol id="ic-logout" viewBox="0 0 24 24">
          <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
          <path d="M16 17l5-5-5-5M21 12H9" />
        </symbol>
        <symbol id="ic-chart" viewBox="0 0 24 24">
          <path d="M18 20V10M12 20V4M6 20v-6" />
        </symbol>
        <symbol id="ic-globe" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" />
          <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
        </symbol>
        <symbol id="ic-download" viewBox="0 0 24 24">
          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
        </symbol>
        <symbol id="trident-icon" viewBox="0 0 100 140">
          <path
            d="M50 138 L50 55"
            stroke="currentColor"
            strokeWidth="6"
            fill="none"
            strokeLinecap="round"
          />
          <path
            d="M50 55 C50 30 38 30 34 10 C48 16 50 30 50 40 C50 30 52 16 66 10 C62 30 50 30 50 55 Z"
            fill="currentColor"
          />
          <path
            d="M14 34 C22 42 32 46 44 46M86 34 C78 42 68 46 56 46"
            stroke="currentColor"
            strokeWidth="6"
            fill="none"
            strokeLinecap="round"
          />
          <ellipse cx="50" cy="128" rx="10" ry="6" fill="currentColor" />
        </symbol>
      </defs>
    </svg>
  );
}
